import React from "react";
import {
  Text,
  TextInput,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import SelectDropdown from "react-native-select-dropdown";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import EventNameWalkthrough from "../walk-through-common-components/createEventTooltips/EventNameWalkthrough";

const EventNameAndGameComponent = ({
  eventName,
  setEventName,
  games,
  setSelectGame,
  normalizedSelectGame,
}) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  return (
    <View style={styles.mainInputWrapper}>
      <View style={styles.leftWrapper}>
        <EventNameWalkthrough />
        <View style={[styles.inputWrapper]}>
          <TextInput
            placeholder={"My new streaming"}
            multiline={false}
            placeholderTextColor={AppColors.gray_C4C4C4}
            style={[AppFontStyle.REGULAR_ANYBODY_12, styles.textInputStyle]}
            // ref={refValue}
            onSubmitEditing={() => {}}
            onChangeText={(text) => {
              setEventName(text);
            }}
            keyboardType="default"
            secureTextEntry={false}
            value={eventName}
          />
        </View>
      </View>
      <View style={styles.leftWrapper}>
        <Text style={[AppFontStyle.REGULAR_ANYBODY_12, , {}]}>
          Select the game
        </Text>
        <SelectDropdown
          data={games}
          onSelect={(selectedItem) => {
            setSelectGame(selectedItem);
          }}
          defaultValue={normalizedSelectGame}
          renderButton={(selectedItem, isOpened) => {
            return (
              <View style={styles.dropdownButtonStyle}>
                <Text
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    styles.dropdownButtonTxtStyle,
                    {
                      color: AppColors.white,
                    },
                  ]}
                >
                  {selectedItem || "Select a game"}
                </Text>
                <Icon
                  name={isOpened ? "chevron-up" : "chevron-down"}
                  style={styles.dropdownButtonArrowStyle}
                />
              </View>
            );
          }}
          renderItem={(item, index, isSelected) => {
            return (
              <View
                style={{
                  ...styles.dropdownItemStyle,
                  ...(isSelected && {
                    backgroundColor: "#D2D9DF",
                  }),
                }}
              >
                <Text style={styles.dropdownItemTxtStyle}>{item}</Text>
              </View>
            );
          }}
          search={true}
          searchInputTxtColor={AppColors.white}
          searchInputStyle={styles.searchInputStyle}
          dropdownStyle={styles.dropdownMenuStyle}
          showsVerticalScrollIndicator={false}
        />
      </View>
    </View>
  );
};

export default EventNameAndGameComponent;

const useStyles = CreateResponsiveStyle(
  {
    mainInputWrapper: {
      flexDirection: "row",
      gap: 25,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 12,
    },
    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      // paddingHorizontal: 10,
      color: AppColors.white,
      outlineStyle: "none",
    },
    dropdownItemStyle: {
      width: "100%",
      flexDirection: "row",
      paddingHorizontal: 12,
      justifyContent: "center",
      alignItems: "center",
      paddingVertical: 8,
    },
    dropdownButtonStyle: {
      width: "100%",
      height: 50,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 12,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      paddingHorizontal: 12,
    },
    dropdownButtonTxtStyle: {
      flex: 1,
      color: AppColors.white,
    },
    dropdownButtonArrowStyle: {
      fontSize: 28,
      color: AppColors.white,
    },
    dropdownMenuStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginTop: 10,
    },

    dropdownItemTxtStyle: {
      flex: 1,
      fontSize: 18,
      fontWeight: "500",
      color: AppColors.white,
    },
    searchInputStyle: {
      height: 40,
      marginTop: 10,
      fontSize: 16,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainInputWrapper: {
        flexDirection: "row",
        gap: 25,
      },
      leftWrapper: {
        flex: 0.5,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      inputWrapper: {
        flex: 1,
      },
    },

    [DEVICE_SIZES.XS]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      inputWrapper: {
        flex: 1,
      },
    },
  }
);
